module.exports = __webpack_public_path__ + "img/drowfunction.09fb5ebb.png";